import {
  CREDIT_AGENT_START,
  CREDIT_AGENT_ERROR,
  CREDIT_AGENT_SUCCESS,
} from 'constants/action-types/wallets/creditAgent';

import apiAction from 'helpers/apiAction';
import {
  CREDIT_DESTINATION_USER,
  CREDIT_DESTINATION_GROUP,
} from 'constants/walletCreditDefaults';
import notificationHelper from 'helpers/notificationHelper';
import { ERROR } from 'constants/notificationStatus';

const onSuccess = (dispatch, payload) => {
  dispatch({ type: CREDIT_AGENT_SUCCESS, payload });
  notificationHelper({ message: payload.message });
};

const onFailure = (dispatch, error) => {
  dispatch({ type: CREDIT_AGENT_ERROR, error });
  if (error) {
    if (!error.errors) {
      notificationHelper({ message: error.message, status: ERROR });
    }
    if (error.errors) {
      notificationHelper({
        message: error.errors[0].message,
        status: ERROR,
      });
    }
  }
};

export const creditAgent = (data, agentId) => dispatch =>
  dispatch(
    apiAction({
      url: `/wallets/agents/${agentId}`,
      method: 'POST',
      data: {
        amount: data.amount,
        purpose: data.description,
      },
      API_REQUEST_START: CREDIT_AGENT_START,
      API_REQUEST_SUCCESS: CREDIT_AGENT_SUCCESS,
      API_REQUEST_FAILURE: CREDIT_AGENT_ERROR,
      onSuccess: payload => onSuccess(dispatch, payload),
      onFailure: error => onFailure(dispatch, error),
      onEnd: () => false,
    }),
  );

export const creditGroup = (data, groupId) => dispatch =>
  dispatch(
    apiAction({
      url: `/wallets/topup?group_id=${groupId}`,
      method: 'POST',
      data: {
        destination: CREDIT_DESTINATION_GROUP,
        organization_id: data.organization_id || undefined,
        channel: data.channel,
        source: data.source,
        amount: data.amount,
        description: data.description,
      },
      API_REQUEST_START: CREDIT_AGENT_START,
      API_REQUEST_SUCCESS: CREDIT_AGENT_SUCCESS,
      API_REQUEST_FAILURE: CREDIT_AGENT_ERROR,
      onSuccess: payload => onSuccess(dispatch, payload),
      onFailure: error => onFailure(dispatch, error),
      onEnd: () => false,
    }),
  );

export const creditUser = (data, userId) => dispatch =>
  dispatch(
    apiAction({
      url: `/wallets/topup?user_id=${userId}`,
      method: 'POST',
      data: {
        destination: CREDIT_DESTINATION_USER,
        organization_id: data.organization_id || undefined,
        channel: data.channel,
        source: data.source,
        amount: data.amount,
        description: data.description,
      },
      API_REQUEST_START: CREDIT_AGENT_START,
      API_REQUEST_SUCCESS: CREDIT_AGENT_SUCCESS,
      API_REQUEST_FAILURE: CREDIT_AGENT_ERROR,
      onSuccess: payload => onSuccess(dispatch, payload),
      onFailure: error => onFailure(dispatch, error),
      onEnd: () => false,
    }),
  );

export const creditBulkUsers = data => dispatch =>
  dispatch(
    apiAction({
      url: '/wallets/bulk-topup',
      method: 'POST',
      data: {
        users: data.users,
        source: data.source,
        destination: CREDIT_DESTINATION_USER,
        channel: data.channel,
        organization_id: data.organization_id || undefined,
        description: data.description,
      },
      API_REQUEST_START: CREDIT_AGENT_START,
      API_REQUEST_SUCCESS: CREDIT_AGENT_SUCCESS,
      API_REQUEST_FAILURE: CREDIT_AGENT_ERROR,
      onSuccess: payload => onSuccess(dispatch, payload),
      onFailure: error => onFailure(dispatch, error),
      onEnd: () => false,
    }),
  );

export const creditBulkGroups = data => dispatch =>
  dispatch(
    apiAction({
      url: '/wallets/groups/bulk-topup',
      method: 'POST',
      data: {
        groups: data.groups,
        source: data.source,
        destination: CREDIT_DESTINATION_GROUP,
        channel: data.channel,
        organization_id: data.organization_id || undefined,
        description: data.description,
      },
      API_REQUEST_START: CREDIT_AGENT_START,
      API_REQUEST_SUCCESS: CREDIT_AGENT_SUCCESS,
      API_REQUEST_FAILURE: CREDIT_AGENT_ERROR,
      onSuccess: payload => onSuccess(dispatch, payload),
      onFailure: error => onFailure(dispatch, error),
      onEnd: () => false,
    }),
  );
